import { useEffect, useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Briefcase, CheckCircle, XCircle, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("verifying"); // verifying, success, error
  const [message, setMessage] = useState("");

  useEffect(() => {
    const token = searchParams.get("token");
    if (token) {
      verifyToken(token);
    } else {
      setStatus("error");
      setMessage("No verification token provided");
    }
  }, [searchParams]);

  const verifyToken = async (token) => {
    try {
      await axios.post(`${API}/auth/verify-email`, { token });
      setStatus("success");
      setMessage("Your email has been verified successfully!");
    } catch (error) {
      setStatus("error");
      setMessage(error.response?.data?.detail || "Verification failed. The link may have expired.");
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-accent/50 to-background flex items-center justify-center px-4">
      <Card className="w-full max-w-md shadow-xl">
        <CardContent className="p-8 text-center">
          <div className="w-16 h-16 mx-auto mb-6 rounded-full flex items-center justify-center" 
               style={{ backgroundColor: status === "success" ? "#dcfce7" : status === "error" ? "#fee2e2" : "#f3f4f6" }}>
            {status === "verifying" && <Loader2 className="w-8 h-8 text-gray-500 animate-spin" />}
            {status === "success" && <CheckCircle className="w-8 h-8 text-green-600" />}
            {status === "error" && <XCircle className="w-8 h-8 text-red-600" />}
          </div>
          
          <h1 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
            {status === "verifying" && "Verifying..."}
            {status === "success" && "Email Verified!"}
            {status === "error" && "Verification Failed"}
          </h1>
          
          <p className="text-muted-foreground mb-6">{message}</p>
          
          {status === "success" && (
            <Button onClick={() => navigate("/login")} className="w-full">
              Continue to Login
            </Button>
          )}
          
          {status === "error" && (
            <div className="space-y-3">
              <Button onClick={() => navigate("/login")} variant="outline" className="w-full">
                Back to Login
              </Button>
              <p className="text-sm text-muted-foreground">
                Need a new link? Sign up again or contact support.
              </p>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default VerifyEmailPage;
